import React from 'react'
import {
  FluidImage,
  Banner,
  BannerTextContainer,
  BannerText,
  BannerTitle,
  BannerDescription,
  BannerImageContainer,
  BannerImage,
  BannerLinks,
  Button,
  Icon,
  P,
} from '@vp/swan'

import { redirect } from '../../../common/Redirect'
import { trackGwsPromotionClick } from '../WixDomainsPDPAnalytics'
import { CommonFeatures } from '../../../../types/CommonFeatures'

async function redirectToGWS(url: string) {
  trackGwsPromotionClick()
  redirect(url)
}

interface GwsPromoProps {
  content: CommonFeatures
  url: string
}

const GwsPromo = ({ content, url }: GwsPromoProps) => {
  return (
    <Banner variant="full-width-image">
      <BannerTextContainer pt={6}>
        <BannerText>
          <BannerTitle>{content.features?.[0].name}</BannerTitle>
          <BannerDescription>
            <P>{content.features?.[0].description}</P>
          </BannerDescription>
          <BannerLinks>
            <Button
              skin="primary"
              onClick={() => {
                redirectToGWS(url)
              }}
            >
              {content.features?.[1].name}
              <Icon iconType="arrowRight" />
            </Button>
          </BannerLinks>
        </BannerText>
      </BannerTextContainer>
      <BannerImageContainer>
        <BannerImage>
          <FluidImage
            srcSet={content.features?.[0].mediaLink?.[0].secure_url}
            style={{
              objectPosition: '80%',
            }}
            alt={content.features?.[0].name}
          />
        </BannerImage>
      </BannerImageContainer>
    </Banner>
  )
}

export default GwsPromo
